<template>
  <b-card
    :title="item.boxTitle||'...'"
  >
    <form-scheduled-box
      :key="'scheduledboxform'"
      ref="scheduledBox_form"
      v-model="item"
      @submit="success"
      @run_success="run_success"
    />
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      class="d-inline-block mr-1"
      @click="formSubmit"
    >
      {{ $t('Save') }}
    </b-button>

    <b-button
      v-if="item.id"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="success"
      class="d-inline-block mr-1"
      @click="run"
    >
      {{ $t('Run') }}
    </b-button>

  </b-card>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BButton, BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import FormScheduledBox from '@/layouts/components/forms/FormScheduledBox.vue'

export default {
  components: {
    BCard,
    BButton,
    FormScheduledBox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      item: {
        boxTitle: null,
      },
    }
  },
  created() {
    if (this.$route.params.id && this.$route.params.id > 0) {
      this.initDetail()
    }
  },
  methods: {
    success() {
      this.$swal({
        icon: 'success',
        title: 'Saved!',
        text: 'Saved successfuly.',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    run_success() {
      this.$swal({
        icon: 'success',
        title: 'Completed!',
        text: 'Completed successfuly.',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    formSubmit() {
      this.$refs.scheduledBox_form.validationForm()
    },
    run() {
      this.$refs.scheduledBox_form.run()
    },
    initDetail() {
      useJwt.axiosIns.get(`scheduledbox/${this.$route.params.id}`)
        .then(response => {
          if (response.data) {
            this.item = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>
